import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../api/supabase';

export default function MobileClients() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!q && rows.length > 0) return;
    setLoading(true);
    let query = supabase.from('clients')
      .select('id, full_name, client_code, phone, email')
      .eq('is_active', true)
      .order('full_name')
      .limit(40);
    if (q) query = query.or(`full_name.ilike.%${q}%,client_code.ilike.%${q}%,phone.ilike.%${q}%`);
    const { data } = await query;
    setRows(data || []);
    setLoading(false);
  }, [q]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ padding: '20px 16px', paddingBottom: 80 }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1a1a2e', marginBottom: 16 }}>Clients</div>
      <input
        className="form-input"
        placeholder="Search name, code or phone…"
        value={q}
        onChange={e => setQ(e.target.value)}
        style={{ marginBottom: 16, fontSize: 15 }}
      />
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Loading…</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
          {rows.length === 0 && <div style={{ padding: '24px 16px', color: '#aaa', fontSize: 13, textAlign: 'center' }}>No clients found</div>}
          {rows.map((c, i) => (
            <div key={c.id} onClick={() => navigate(`/clients/${c.id}`)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderBottom: i < rows.length - 1 ? '1px solid #f3f3f3' : 'none', cursor: 'pointer' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#1a1a2e' }}>{c.full_name}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 3 }}>{c.client_code}</div>
                {c.phone && <div style={{ fontSize: 12, color: '#888' }}>{c.phone}</div>}
              </div>
              <div style={{ fontSize: 11, color: '#bbb' }}>View →</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
